import axios from "axios";
import Vue from 'vue'; // 引入 Vue 实例，用于访问 $bus
import { MessageBox, Message } from 'element-ui'
import QS from "qs";
import { hex_url, hex_obj } from "./securityCode"; // 没有使用,注释掉. 如果要使用,需要讨论,会对qiankun框架造成影响
import "./security.js";
import store from "../store/store";
if (location.href.indexOf("uuid") != -1) {
  axios.defaults.withCredentials = true;
}

axios.interceptors.request.use(config => {
  // 写入取消请求的标识
  config.cancelToken = new axios.CancelToken(cancel => {
    store.commit('addCancelToken', cancel)
  })

  // 给每个接口添加token, 如果token存在，赋值到headers,不能再外面定义，进入请求获取之后再获取token
  // config.headers.appId = '2222'
  // config.url = hex_url(config.url, config.method)
  if (localStorage.getItem("uuid")) {
    config.headers.uuid = localStorage.getItem("uuid");
  }
  if (sessionStorage.getItem("token")) {
    config.headers.authToken = sessionStorage.getItem("token");
    // config.headers.authToken = 'edf60ba030484deaa1d5a0719d483d73'; //本地开发使用  打包时注释掉
    if (
      location.href.indexOf("localhost") != -1 ||
      location.href.indexOf("192.168") != -1
    ) {
      // config.headers.appId = '8219'
    }
    // vip会员模块
    if (config.url.indexOf("CommonApi") != -1 && location.href.indexOf("offprint") == -1) {
      // 获取读者俱乐部的接口 如果有specids 就是获取下载量等，需要修改queryType\
      if (config.data && config.data.productId) {
        config.headers.queryType = "query_vip_sku_info";
      } else if (config.data && config.data.resId) {
        config.headers.queryType = "query_product_detail_info";
      } else if (config.data && config.data.type) {
        config.headers.queryType = "query_vip_product_list";
        delete config.data.type
      } else if (config.data && config.data.id) {
        config.headers.queryType = "query_vip_product_list";
      } else if (config.data && config.data.resourceId && config.data.code) { // 合集集锦 > 选购合集 > 订单
        config.headers.queryType = "query_product_info";
      } else {
        config.headers.queryType = "query_product_list";
      }
    }
    // 机构模块 || 最近阅读
    if (
      config.url.indexOf("common") != -1 &&
      config.url.indexOf("invoice") == -1
    ) {
      if (
        config.url.indexOf("queryString") != -1 ||
        config.params.queryString
      ) {
        config.headers.queryType = "queryStringSearch";
      } else if (config.params.getSite) {
        config.headers.queryType = "getSite";
        delete config.params.getSite;
      } else if (config.params.getIssueparam) {
        config.headers.queryType = "getIssue";
        delete config.params.getIssueparam;
      } else if (config.params.type) {
        config.headers.queryType = "directoryGraphql";
        delete config.params.type;
      } else {
        config.headers.queryType = "dataBase";
      }
    }
    if (config.url.indexOf("user_third_login") != -1 && config.url.indexOf("weibo") != -1) {
      config.headers['Content-Type'] = 'application/json'
    }
    if (config.url.indexOf("SpcMemberCancel/status") != -1) {
      config.headers['Content-Type'] = 'application/json'
    }
    // if (  config.url.indexOf("common") != -1 ) {
    //   if (config.data && config.data.journalId) {
    //     config.headers.queryType = "directoryGraphql";
    //   }
    // }
  }
  return config;
});
// 响应拦截
axios.interceptors.response.use(

  response => {
    // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据;否则的话抛出错误
    if (response.status == 200 || response.status == 201) {
      if ((response.data.status == 100102 || response.data.status == 100101) && response.config.url.indexOf('/member/cas/logout/') == -1) {
        location.reload();

        // MessageBox.confirm(
        //   'token 失效请刷新页面',
        //   '系统提示',
        //   {
        //     showClose: false,
        //     showCancelButton: false,
        //     confirmButtonText: '确定',
        //     type: 'warning'
        //   }
        // )
        //   .then(() => {
        //     let int = setInterval(() => {
        //       const ele = document.getElementsByClassName('v-modal')[0]
        //       // 当检测到document中没有遮罩层的时候 清除计时器
        //       if (!ele) {
        //         clearInterval(int)
        //       } else {
        //         // 进行点击，触发弹窗的关闭
        //         ele.click()
        //       }
        //     }, 0)
        //     location.reload();
        //   })
        //   .catch(() => { })

      } else if (response.data.status === 100112) { //
        Vue.prototype.$bus.$emit('logout', 1);
        let url =
            window.location.protocol +
            "//" +
            window.location.host +
            "/LoginSignOUT?userId=" + localStorage.getItem("memberId");
        location.href = url
      } else if (response.data.status === 100113) {
        Vue.prototype.$bus.$emit('logout', 2);
        // location.href = localStorage.getItem("casLogin")
      }
      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    }
  },
  error => {
    if (error.response.status) {
      switch (error.response.status) {
        case 404:
          break;
        case 401:
          break;
        case 400:
          break;
        default:
      }
      return Promise.reject(error.response);
    }
  }
);

export function Post(url, params, type) {
  return new Promise((resolve, reject) => {
    params = type == "isJson" ? params : QS.stringify(params);
    axios
      .post(url, params)
      .then(res => {
        if (res.data == 401) {
          if (location.href.indexOf('getPass') !== -1) {
            return
          }
          if (location.href.indexOf('reg') !== -1) {
            return
          }
          let url = encodeURIComponent(location.href);
          console.log(url, 'url--Post');
          let codes =
            window.location.protocol +
            "//" +
            window.location.host +
            "/member/cas/auth?redirectUrl=" +
            url;
          console.log(codes, 'codes--Post');
          console.log(localStorage.getItem("casLogin") + "?service=" + encodeURIComponent(codes), '跳转的地址--Post');
          location.href =
            localStorage.getItem("casLogin") + "?service=" + encodeURIComponent(codes);
          store.commit("clearCancelToken");
          localStorage.removeItem("addLoginNameId");
          localStorage.removeItem("time");
          localStorage.removeItem("memberId");
          localStorage.removeItem("addLoginName");
          localStorage.removeItem("loginName");
          localStorage.removeItem("gy");
          localStorage.removeItem("uuid");
          sessionStorage.clear();
        } else {
          resolve(res.data);
        }
      })
      .catch(err => {
        reject(err.data);
      });
  });
}
export function Get(url, params, type) {
  return new Promise((resolve, reject) => {
    let a = location.href.indexOf("&ticket=");
    let b = location.href.indexOf("#/personal");
    let tick = location.href.substring(a + 8, b);
    axios
      .get(url, {
        params: params
      })
      .then(res => {
        if (res.data == 401) {
          if (location.href.indexOf('getPass') !== -1) {
            return
          }
          if (location.href.indexOf('reg') !== -1) {
            return
          }
          if (location.href.indexOf('offprint') !== -1) {
            return
          }
          let url = encodeURIComponent(location.href);
          console.log(url, 'url--get');
          let codes =
            window.location.protocol +
            "//" +
            window.location.host +
            "/member/cas/auth?redirectUrl=" +
            url;
          console.log(codes, 'codes--get');
          console.log(localStorage.getItem("casLogin") + "?service=" + codes, '跳转的地址--get');
          location.href =
            localStorage.getItem("casLogin") + "?service=" + encodeURIComponent(codes);
          store.commit("clearCancelToken");
          localStorage.removeItem("addLoginNameId");
          localStorage.removeItem("time");
          localStorage.removeItem("memberId");
          localStorage.removeItem("addLoginName");
          localStorage.removeItem("loginName");
          localStorage.removeItem("gy");
          localStorage.removeItem("uuid");
          sessionStorage.clear();
        }
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data);
      });
  });
}
// var Get = axios.get
// var Post = axios.post
var Put = axios.put;
var Delete = axios.delete;

export { Put, Delete };



// WEBPACK FOOTER //
// ./src/api/axios.js